import { render, staticRenderFns } from "./process-dashboard-filter.vue?vue&type=template&id=a45195f2"
import script from "./process-dashboard-filter.vue?vue&type=script&lang=js"
export * from "./process-dashboard-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports